<template>
    <div>
        <ListPage
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
        >
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="筛选项名称" clearable @keyup.enter.native="handleSearch" />
                </el-form-item>
            </template>
            <template slot="btns" v-if="permission('cpgl_sxqgl_xz')">
                <el-button size="mini" type="primary" @click="handleAdd"> 添加筛选项 </el-button>
            </template>
            <template slot="columns">
                <el-table-column label="排序" align="center" prop="sort" />
                <el-table-column label="筛选项名称" align="center" prop="name" />
                <el-table-column label="参数量" align="center" prop="item_count" />
                <el-table-column label="是否显示" align="center" prop="status">
                    <template slot-scope="{ row }">
                        {{ row.status == 1 ? "显示" : "不显示" }}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="create_time" />
                <el-table-column
                    v-if="permission('cpgl_sxqgl_ck') || permission('cpgl_sxqgl_bj') || permission('cpgl_sxqgl_sc')"
                    label="操作"
                    align="center"
                    width="140"
                >
                    <template slot-scope="{ row }">
                        <el-button v-if="permission('cpgl_sxqgl_ck')" size="mini" type="text" @click="handleDetail(row)"> 查看 </el-button>
                        <el-button v-if="permission('cpgl_sxqgl_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                        <el-button v-if="permission('cpgl_sxqgl_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <FormVue ref="form" @update="search"></FormVue>
        <DetailVue ref="detail" @update="search"></DetailVue>
    </div>
</template>

<script>
import { list, del } from "@/api/product/filter";
import listMixin from "@/mixins/list";
import FormVue from "./form.vue";
import DetailVue from "./detail.vue";

export default {
    components: { FormVue, DetailVue },
    data() {
        return {
            del,
            list,
            // 查询参数
            query: {
                search_keyword: "",
            },
            module: "筛选器",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleAdd() {
            this.$refs.form.open();
        },
        handleEdit(row) {
            this.$refs.form.open(row);
        },
        handleDetail(row) {
            this.$refs.detail.open(row);
        },
    },
};
</script>
